.OptionalFilterLabel {
  position: relative;
  display: grid;
  grid: auto / 1fr max-content;
  align-items: center;
  place-self: initial;
  gap: var(--space-sm);
  padding: var(--space-sm) var(--space-lg);
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--black);

  &:has(:checked) [data-slot="text"] {
    color: var(--black);
  }
}

.OptionalFilterContent {
  display: contents;
}

.hidden {
  display: none;
}
